<template>
  <div>
    <Head :title="form.name" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/agencies">Agencies</Link></li>
        <li class="breadcrumb-item"><Link :href="`/agencies/${agencies.id}/view`">{{ form.name }}</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Edit {{ form.name }}</li>
      </ol>
    </nav>
    <h1>
      {{ form.name }}
    </h1>
    <trashed-message v-if="agencies.deleted_at" class="mb-6" @restore="restore"> This agency has been deleted. </trashed-message>

    <div class="content-box mb-3">
      <form @submit.prevent="update">
        <AgencyForm :form="form" />

        <div class="actions-toolbar d-flex justify-content-between">
          <loading-button :loading="form.processing" class="btn btn-success" type="submit">Update Agency</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import AgencyForm from './components/AgencyForm'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    AgencyForm,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    agencies: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.agencies.name,
        email: this.agencies.email,
        phone: this.agencies.phone,
        address_1: this.agencies.address_1,
        address_2: this.agencies.address_2,
        city: this.agencies.city,
        region: this.agencies.region,
        country: this.agencies.country,
        postal_code: this.agencies.postal_code,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/agencies/${this.agencies.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this agency?')) {
        this.$inertia.delete(`/agencies/${this.agencies.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this agency?')) {
        this.$inertia.put(`/agencies/${this.agencies.id}/restore`)
      }
    },
  },
}
</script>
